// Mirrors the copy-count selection already used by CWHardwareController.js / hardWareControllerPrinter.js,
// so the plain-browser (window.print/XML) paths honor the same Till Template configuration.
const getReceiptCopies = (printReciptData, posConfig) => {
  const isLoyaltyPayment =
    (printReciptData.payments && printReciptData.payments.some((payment) => payment.isloyalty)) ||
    (printReciptData?.paymentData && printReciptData?.paymentData.some((payment) => payment?.isloyalty));

  let copies;
  if (printReciptData.isReturn) {
    copies = posConfig?.return_receipt_copies;
  } else if (printReciptData.layAway === "Y" || printReciptData.layAway === true) {
    copies = printReciptData.paid === 0 ? posConfig?.layaway_receipt_copies : posConfig?.layaway_paid_receipt_copies;
  } else if (isLoyaltyPayment) {
    copies = posConfig?.loyalty_receipt_copies;
  } else {
    copies = posConfig?.sales_receipt_copies;
  }

  return copies > 0 ? copies : 1;
};

export default getReceiptCopies;
